// these fetch calls in separated file that it can be mocked in tests
export default ( uri, opts ) => fetch( uri, opts ).then( async res => ({
  // eslint-disable-next-line promise/no-nesting
  json: await res.json().catch( () => res.text() ),
  status: res.status,
  statusText: res.statusText,
  redirected: res.redirected,
  url: res.url
}) ).catch( e => e );

export const reqOpenIdConfigGET = async opts => (
  fetch( opts.openid_uri || '', {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  }) )
  .then( async res => res.json() )
  .then( res => Object.assign( res, opts.openid || {}) )
  .catch( e => e );
